<template>
  <div class="d-flex justify-content-center">
    <h1>Combat</h1>
  </div>
</template>
      
  <script>
import { mapMutations } from 'vuex'
//----------------------
// scripts
//----------------------
export default {
  name: 'CombatPlayerView',
  //----------------------
  // components
  //----------------------
  components: {},
  //----------------------
  // props
  //----------------------
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  //----------------------
  // data
  //----------------------
  data() {
    return {
      // errors: [],
      // errorFields: [],
      // defaultImage: import("/assets/images/default-arena-image.png"),
    }
  },
  //----------------------
  // computed
  //----------------------
  computed: {
    //   ...mapGetters("auth", {
    //     getHeaders: "getHeaders",
    //     getImgHeaders: "getImgHeaders",
    //   }),
    //   isArenaChanged() {
    //     if (
    //       this.sv_arena_description != this.arena_description ||
    //       this.sv_arena_name != this.arena_name ||
    //       JSON.stringify(this.sv_selections) != JSON.stringify(this.selections)
    //     ) {
    //       if (this.arena_name) {
    //         return true;
    //       }
    //     }
    //     return false;
    //   },
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapMutations('auth', {
      setCurrentView: 'setCurrentView',
    }),
    SetView(view) {
      this.setCurrentView(view)
    },
  },
  //-------------------------
  // on mount
  //-------------------------
  mounted() {
    this.SetView('player_combat')
  },
  created() {
    //   if (this.$route.params.slug != null) {
    //     this.getArena();
    //   }
  },
}
</script>